import { Route, Routes } from 'react-router-dom'

import buildLink from 'utils/buildLink'

import { PaymentsProvider } from 'components/PaymentsProvider'
import BuyVoucher from 'components/pages/Gift'
import VoucherReview from 'components/pages/VoucherReview'
import { PathArgs } from '../types'

export function voucherPath(args?: PathArgs): string {
  return buildLink({ ...args, path: '/account/gifts/voucher' })
}
export function voucherReviewPath(args?: PathArgs): string {
  return buildLink({ ...args, path: '/account/gifts/voucher/review' })
}

export default function VoucherFlow(): JSX.Element {
  return (
    <PaymentsProvider>
      <Routes>
        <Route path='review' element={<VoucherReview />} />
        <Route path='' element={<BuyVoucher />} />
      </Routes>
    </PaymentsProvider>
  )
}
